var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclusivityBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40775 12.2673L7.55775 10.3673L10.7078 12.2923L9.88275 8.69225L12.6578 6.29225L9.00775 5.96725L7.55775 2.56725L6.10775 5.94225L2.45775 6.26725L5.23275 8.69225L4.40775 12.2673ZM2.88275 14.3652L4.12325 9.05175L0 5.48075L5.43075 5.0095L7.55775 0L9.68475 5.0095L15.1155 5.48075L10.9923 9.05175L12.2327 14.3652L7.55775 11.5442L2.88275 14.3652Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusivityBlack);
export default __webpack_public_path__ + "static/media/exclusivity-black.58e7c210c27ef91f687c82512585bc26.svg";
export { ForwardRef as ReactComponent };